import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "./Logo";

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (p) => location.pathname === p;
  const activeCls = (p) => `nav-item ${isActive(p) ? "nav-item-active" : ""}`;

  const handleDealsClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  const handleHomeClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <>
      <header
        className="sticky top-0 z-40 backdrop-blur-xl bg-[#111111]/90 border-b border-[#2A2A2A]"
        data-testid="site-header"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-20 flex items-center justify-between">
          <Logo />

          <nav className="hidden md:flex items-center gap-10">
            <Link to="/" onClick={handleHomeClick} className={activeCls("/")} data-testid="nav-home">Home</Link>
            <a href="/#feed" onClick={handleDealsClick} className="nav-item" data-testid="nav-deals">Deals</a>
            <Link to="/guides" className={activeCls("/guides")} data-testid="nav-guides">Guides</Link>
            <Link to="/subscribe" className={activeCls("/subscribe")} data-testid="nav-subscribe">Subscribe</Link>
          </nav>

          <Link to="/subscribe" className="btn-rd md:hidden !py-2.5 !px-3 !text-[0.65rem]" data-testid="header-cta-mobile">
            SUBSCRIBE
          </Link>
        </div>
      </header>

      {/* Mobile bottom navigation bar — hidden on md+ */}
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#111111] border-t border-[#CC1A1A] flex justify-around py-3"
        data-testid="mobile-bottom-nav"
      >
        <Link
          to="/"
          onClick={handleHomeClick}
          className={`font-mono text-[11px] tracking-[0.1em] uppercase transition-colors ${isActive("/") ? "text-[#CC1A1A]" : "text-[#555555] hover:text-[#CC1A1A]"}`}
          data-testid="mobile-nav-home"
        >
          HOME
        </Link>
        <a
          href="/#feed"
          onClick={handleDealsClick}
          className="font-mono text-[11px] tracking-[0.1em] uppercase transition-colors text-[#555555] hover:text-[#CC1A1A]"
          data-testid="mobile-nav-deals"
        >
          DEALS
        </a>
        <Link
          to="/guides"
          className={`font-mono text-[11px] tracking-[0.1em] uppercase transition-colors ${isActive("/guides") ? "text-[#CC1A1A]" : "text-[#555555] hover:text-[#CC1A1A]"}`}
          data-testid="mobile-nav-guides"
        >
          GUIDES
        </Link>
        <Link
          to="/subscribe"
          className={`font-mono text-[11px] tracking-[0.1em] uppercase transition-colors ${isActive("/subscribe") ? "text-[#CC1A1A]" : "text-[#555555] hover:text-[#CC1A1A]"}`}
          data-testid="mobile-nav-subscribe"
        >
          SUBSCRIBE
        </Link>
      </nav>
    </>
  );
}
